/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import BASEScrollbars from "../../../../../@BASE/core/BASEScrollbars";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { memo } from "react";
import Logo from "../../../shared-components/Logo";
import NavbarToggleButton from "../../../shared-components/NavbarToggleButton";
import Navigation from "../../../shared-components/Navigation";

const Root = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.gui,
  color: theme.palette.text.white,
  "& ::-webkit-scrollbar-thumb": {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === "light"
        ? "rgba(0, 0, 0, 0.24)"
        : "rgba(255, 255, 255, 0.24)"
    }`,
  },
  "& ::-webkit-scrollbar-thumb:active": {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === "light"
        ? "rgba(0, 0, 0, 0.37)"
        : "rgba(255, 255, 255, 0.37)"
    }`,
  },
}));

const StyledContent = styled(BASEScrollbars)(({ theme }) => ({
  overscrollBehavior: "contain",
  overflowX: "hidden",
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 40px, 100% 10px",
  backgroundAttachment: "local, scroll",
}));

function NavbarStyleContent(props) {
  return (
    <Root
      className={clsx(
        "flex flex-auto flex-col overflow-hidden h-full",
        props.className
      )}
    >
      <div className="flex flex-row items-center shrink-0 h-48 md:h-64 px-20" style={{ color: "#ffffff" }}>
        <div className="flex flex-1 mx-4">
          <div className="flex items-center" id="nav-logo">
            <Logo />

            <div className="flex flex-col ml-10">
              <span className="text-15 font-bold tracking-logo">BASE</span>
              <span className="text-10">Learning Repository</span>
            </div>
          </div>
        </div>

        <NavbarToggleButton className="w-40 h-40 p-0 text-white" />
      </div>

      <StyledContent
        className="flex flex-1 flex-col min-h-0"
        option={{ suppressScrollX: true, wheelPropagation: false }}
      >
        {/* <UserNavbarHeader /> */}

        <Navigation layout="vertical" />
      </StyledContent>
    </Root>
  );
}

export default memo(NavbarStyleContent);
